module.exports = __webpack_public_path__ + "img/简易编辑.fbe31c2a.gif";